import qs from "qs";

const utils = {
  /**
   * 监听URL变化，并自动跳转到id对应的元素
   * @param {*} context
   * @param {*} newRoute
   */
  watchRouteGoAnchor(context, offset = 0) {
    const id = context.$route.query.goAnchor;
    if (id) utils.goAnchor(context, `#${id}`, offset);
    context.$router.push({
      name: context.$route.name,
      query: context.$route.query
    });
  },
  /**
   * 跳转到页面上的id对应的元素
   * @param { String } context    当前上下文
   * @param { String } selector   元素选择器
   */
  goAnchor(context, selector, offset = 0) {
    let anchor = context.$el.querySelector(selector);
    if (anchor) window.scrollTo(0, anchor.offsetTop + offset);
  },
  postUrlDeal(data) {
    return qs.stringify(data);
  },
  getDomainUrl() {
    return {
      test: "http://127.0.0.1:8040",
      development: "http://127.0.0.1:8040",
      dev: "http://api.xiangyun360.com:8015",
      production: "http://xyserver.clfirst.com"
    }[process.env.NODE_ENV];
  }
};

export default utils;



// WEBPACK FOOTER //
// ./src/utils/utils.js